import type { OrganisationWebhookStatus } from '@risksmart-app/domain/src/types/consts/organisation-webhook-status';
import type { UpdateOrganisationWebhookMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateOrganisationWebhookDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface UpdateWebhookInput {
  id: string;
  Title: string;
  Description: string | null;
  WebhookUrl: string;
  WebhookApiVersion: string;
  Status: OrganisationWebhookStatus;
  WebhookEventTypeIds: string[];
}

export const useUpdateWebhook = createMutationHook({
  name: 'updateWebhook',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.webhook.update.mutationOptions({ onSuccess }),
  mapInput: (input: UpdateWebhookInput) => input,
  invalidate: (trpc) => [trpc.frontend.webhook.list.queryKey()],
  mapResponse: (): UpdateOrganisationWebhookMutation => ({
    updateOrganisationWebhookApi: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateOrganisationWebhookDocument,
  graphqlVariables: (input: UpdateWebhookInput) => ({
    object: {
      Id: input.id,
      Title: input.Title,
      Description: input.Description,
      WebhookUrl: input.WebhookUrl,
      WebhookApiVersion: input.WebhookApiVersion,
      Status: input.Status,
      WebhookEventTypeIds: input.WebhookEventTypeIds,
    },
  }),
  evictFields: ['organisation_webhook'],
});
